import React, { memo, Fragment, useEffect } from 'react';
import { FormInput } from '@core/components/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { Col, Row, Label } from 'reactstrap';
import { TodoListSectionForm } from './TodoListBlock';

export interface TodoListSectionItemProps {
  control: TodoListSectionForm;
}

export const TodoListSectionItem = memo((props: TodoListSectionItemProps) => {
  const { control } = props;
  const items = useObservable(control.controls.items.items$, []);

  useEffect(() => {
    if (items.length === 0) {
      control.controls.items.push();
    }
  }, [control.controls.items, items]);

  return (
    <Fragment>
      <Label>Answers</Label>
      {items.map((ctrl, index) => {
        return (
          <React.Fragment key={`section-${index}`}>
            <Row>
              <Col md={10}>
                <FormInput control={ctrl.controls.item} />
              </Col>
              <Col md={2}>
                {!index && (
                  <a className="btn btn-outline-primary btn-sm" onClick={() => control.controls.items.push()}>
                    Add Todo
                  </a>
                )}
                {!!index && (
                  <a className="btn btn-outline-danger btn-sm" onClick={() => control.controls.items.removeAt(index)}>
                    <i className="bx bx-x"></i>
                  </a>
                )}
              </Col>
            </Row>
          </React.Fragment>
        );
      })}
    </Fragment>
  );
});
